import React, { useEffect, useState } from "react";
import ToggleDetails from "./ToggleDetails";
import { useDispatch, useSelector } from "react-redux";
import Picking from "./Picking";
import Packing from "./Packing";

function DashboardPicking() {
  const Status = useSelector(
    (state) => state.statistics.PickingStatsToggleStatus
  );
  return (
    <>
      <div className="flex flex-col max-w-5xl mt-2 mb-5 xl:max-w-7xl">
        <div>
          <h2 className="font-Montserrat text-xl font-bold text-black">
            Picking Packing Dashboard
          </h2>
          <div className="border-b-2 border-blue-200 w-20"></div>
        </div>
        <ToggleDetails />
        {Status === "Picking" ? <Picking /> : null}
        {Status === "Packing" ? <Packing /> : null}
      </div>
    </>
  );
}

export default DashboardPicking;
